/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
import { defineMessages } from 'react-intl';

export default defineMessages({
  Invalid: {
    id: 'ValidationError.Phone.Invalid',
    defaultMessage: 'Phone numbers must be only 10 digits.'
  }
});
